export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/comment/icon-creator-802944c99f71f4426db056f0ebe7717c.svg";